export default "__VITE_ASSET__ee379ff1__"